import React from 'react';
import { Box, Text } from '@chakra-ui/react';
import PropTypes from 'prop-types';

function ErrorMessage({ errorMessage }) {
  return (
    <Box justifyContent="flex-start" mt="5px !important" width="100%">
      <Text
        color="error.primary.600"
        fontSize="sm"
        pl="5px"
        textAlign="left"
      >
        {errorMessage}
      </Text>
    </Box>
  );
}

ErrorMessage.propTypes = {
  errorMessage: PropTypes.string
};

export default ErrorMessage;
